import { render } from "./AnalysisTag.vue?vue&type=template&id=1da03ba3"
import script from "./AnalysisTag.vue?vue&type=script&lang=js"
export * from "./AnalysisTag.vue?vue&type=script&lang=js"

import "./AnalysisTag.vue?vue&type=style&index=0&id=1da03ba3&lang=css"
script.render = render

export default script